import React from "react";
import PropTypes from "prop-types"
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Calendar from 'react-calendar'
import Time from "../../utils/Time";
import 'react-calendar/dist/Calendar.css';
import {DISABLED_FROM_TODAY_DURATION, START_OF_TIME} from "../../constants/GeneralConstants"

const TODAY = new Date();
const DISABLED_UNTIL = Time.addTimeToDuration(TODAY, DISABLED_FROM_TODAY_DURATION);
const DISABLED_RANGES = [
    [START_OF_TIME, DISABLED_UNTIL],
];

const DISABLED_TILE_STYLE = {"backgroundColor": "#f0f0f0"};
const RESERVED_CLASS_NAMES = "bg-success";
const BLOCKED_CLASS_NAMES = "bg-warning";


class SpaceManageCalendarView extends React.Component {

    static propTypes = {
        currentSelectionRange: PropTypes.array.isRequired,
        showReservationCrossingSelectionErrorAlert: PropTypes.bool.isRequired,
        blockedDates: PropTypes.array.isRequired,
        reservationRequests: PropTypes.array.isRequired,
        activeReservations: PropTypes.array.isRequired
    };

    componentDidMount() {
        // $('[data-toggle="tooltip"]').tooltip()
    }

    handleBlockSelectedClicked = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.BLOCK_DATES_MEMBER_SPACE_CALENDAR_CLICKED,
            {
                spaceId: this.props.spaceId,
                startDate: Time.stringifyDate(this.props.currentSelectionRange[0]),
                endDate: Time.stringifyDate(this.props.currentSelectionRange[1])
            });
    };

    handleUnblockSelectedClicked = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.UNBLOCK_DATES_MEMBER_SPACE_CALENDAR_CLICKED,
            {
                spaceId: this.props.spaceId,
                startDate: Time.stringifyDate(this.props.currentSelectionRange[0]),
                endDate: Time.stringifyDate(this.props.currentSelectionRange[1])
            });
    };

    handleBlockAllClicked = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.BLOCK_ALL_MEMBER_SPACE_CALENDAR_CLICKED,
            {
                spaceId: this.props.spaceId
            });
    };

    handleUnblockAllClicked = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.UNBLOCK_ALL_MEMBER_SPACE_CALENDAR_CLICKED,
            {
                spaceId: this.props.spaceId
            });
    };

    handleDoneClicked = (event) => {
        EventPublisher.publish(UIInteractionEvents.DONE_WITH_SPACE_CALENDAR_MANAGEMENT_CLICKED, {});
    };

    isRangeSelected() {
        return this.props.currentSelectionRange.length !== 0;
    }

    handleErrorAlertClose = (event) => {
        EventPublisher.publish(UIInteractionEvents.CLOSE_RESERVATION_CROSSING_SELECTION_ERROR_ALERT, {});
    };

    render() {
        const reservedRanges = [];
        for (const activeReservation of this.props.activeReservations) {
            reservedRanges.push(
                [
                    Time.parseDate(activeReservation.startDate),
                    Time.parseDate(activeReservation.endDate)
                ]
            );
        }
        for (const reservationRequest of this.props.reservationRequests) {
            reservedRanges.push(
                [
                    Time.parseDate(reservationRequest.startDate),
                    Time.parseDate(reservationRequest.endDate)
                ]
            );
        }

        const blockedRanges = [];
        for (const blockedRange of this.props.blockedDates) {
            blockedRanges.push(
                [
                    Time.parseDate(blockedRange.startDate),
                    Time.parseDate(blockedRange.endDate)
                ]
            );
        }

        let reservationCrossingSelectionErrorAlert = null;
        if (this.props.showReservationCrossingSelectionErrorAlert) {
            reservationCrossingSelectionErrorAlert = (
                <div className="alert alert-danger fade show" role="alert">
                    It is not possible to block dates with a pending or active reservation on them.
                    <button type="button" className="close" onClick={this.handleErrorAlertClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            );
        }

        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                Manage Space Calendar
                                <span className="float-right">
                                    <button className="btn btn-sm btn-primary" onClick={this.handleDoneClicked}>
                                        <i className="far fa-window-close mr-1" />
                                        Done
                                    </button>
                                </span>
                            </div>
                            <div className="card-body">
                                <div className="row-cols-12 d-flex justify-content-center mb-1">
                                    <div className="btn-group" role="group">
                                        <button
                                            className="btn btn-warning btn-sm"
                                            disabled={!this.isRangeSelected()}
                                            onClick={this.handleBlockSelectedClicked}
                                        >
                                            <i className="fas fa-lock mr-1"/>
                                            Block Selected
                                        </button>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            disabled={!this.isRangeSelected()}
                                            onClick={this.handleUnblockSelectedClicked}
                                        >
                                            <i className="fas fa-lock-open mr-1"/>
                                            Unblock Selected
                                        </button>
                                        <button
                                            className="btn btn-warning btn-sm"
                                            onClick={this.handleBlockAllClicked}
                                        >
                                            <i className="fas fa-lock mr-1"/>
                                            Block All
                                        </button>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={this.handleUnblockAllClicked}
                                        >
                                            <i className="fas fa-lock-open mr-1" />
                                            Unblock All
                                        </button>
                                    </div>
                                </div>
                                <div className="form-group row-cols-12 d-flex justify-content-center">
                                    <Calendar
                                        calendarType="US"
                                        view="month"
                                        selectRange={true}
                                        value={this.isRangeSelected() ? this.props.currentSelectionRange : null}
                                        tileDisabled={
                                            ({date, view}) => {
                                                return Time.isWithinRanges(date, DISABLED_RANGES) ||
                                                    Time.isWithinRanges(date, reservedRanges);
                                            }
                                        }
                                        tileClassName={
                                            ({ date, view }) => {
                                                if (Time.isWithinRanges(date, reservedRanges)) {
                                                    return RESERVED_CLASS_NAMES;
                                                }
                                                if (Time.isWithinRanges(date, blockedRanges)) {
                                                    return BLOCKED_CLASS_NAMES;
                                                }
                                            }
                                        }
                                        onChange={
                                            ([rangeStart, rangeEnd]) => {
                                                EventPublisher.publish(
                                                    UIInteractionEvents.CURRENT_MEMBER_CALENDAR_SELECTION_RANGE_CHANGED,
                                                    {
                                                        currentSelectionStartDate: new Date(rangeStart.toLocaleDateString()),
                                                        currentSelectionEndDate: new Date(rangeEnd.toLocaleDateString())
                                                    });
                                            }
                                        }
                                    />
                                </div>
                                <small id="calendarHelpBlock" className="form-text text-bold d-flex justify-content-center">
                                    <ul>
                                        <li><span style={DISABLED_TILE_STYLE}>Days which are no longer available for reservations.</span></li>
                                        <li><span className={RESERVED_CLASS_NAMES}>Days have an active or pending reservation</span></li>
                                        <li><span className={BLOCKED_CLASS_NAMES}>Days which you have blocked to prevent reservations</span></li>
                                    </ul>
                                </small>
                                <div className="row-cols-12 d-flex justify-content-center">
                                    {reservationCrossingSelectionErrorAlert}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default SpaceManageCalendarView;